export default {
  api_keys: "API 金鑰",
  api_docs: "文件",
  keys_count: "{current} / {total} 金鑰",
  unnamed: "未命名",
  edit_name: "編輯名稱",
  upgrade_to_enable: "升級以啟用 API 金鑰功能",
  no_api_keys: "無 API 金鑰",
  generate_key: "產生金鑰",
  upgrade_to_generate: "升級以產生金鑰",
  api_calls: "API 呼叫",
  endpoint_stats: "端點呼叫統計",
  refresh: "重新整理",
  free_plan_api_stats: "免費方案用戶無法查看 API 呼叫統計。請升級以查看詳細數據。",
  data_updates: "數據每 5 分鐘更新一次",
  api_call_logs: "API 呼叫日誌",
  api_call_logs_desc: "此處僅顯示帶有有效 API 金鑰的請求。數據每 5 分鐘更新一次",
  select_api_key: "選擇 API 金鑰",
  endpoint: "端點",
  response_time: "回應時間",
  api_quota: "API 配額",
  upgrade: "升級",
  current_plan: "目前方案",
  key_count: "金鑰數量",
  call_limit: "呼叫限制",
  no_access: "無存取權限",
  daily_limit: "每日 {limit} 次呼叫",
  total_limit: "總計限制 {limit} 次呼叫",
  monthly_limit: "每月 {limit} 次呼叫",
  calc_quota: "計算配額",
  calc_and_report_quota: "計算和報告配額",
  report_quota: "報告配額",
  daily_report_quota: "每日報告",
  extra_quota: "額外配額：{count} 次呼叫",
  edit_key_name: "編輯金鑰名稱",
  key_name: "金鑰名稱",
  key_name_placeholder: "請為您的金鑰輸入一個名稱",
  key_name_desc: "為您的 API 金鑰指定一個易於識別的名稱",
  feature_restricted: "功能受限",
  feature_restricted_desc1: "您的目前方案無法使用此功能",
  feature_restricted_desc2: "免費方案用戶無法使用 API 金鑰功能。請升級到付費方案以解鎖所有功能。",
  upgrade_benefits: "升級好處：",
  benefit1: "產生和管理 API 金鑰",
  benefit2: "查看 API 呼叫統計和趨勢",
  benefit3: "複製和使用 API 金鑰",
  benefit4: "更高的計算和報告配額",
  benefit5: "更多進階功能",
  response_data_details: "回應數據詳情",
  call_count: "{count} 次呼叫",
  name_required: "名稱不能為空",
  name_too_long: "名稱長度不能超過 20 個字元",
  key_generated: "金鑰產生成功",
  key_deleted: "刪除成功",
  key_updated: "名稱更新成功",
  upgrade_required: "請升級",
  loading_docs: "正在載入 API 文件...",
  docs_load_error: "文件載入失敗",
  docs_load_error_desc: "載入 API 文件時發生錯誤。請稍後再試。",
  close_window: "關閉視窗",
  delete_confirm: "確認刪除？",
  today: "今天",
  this_month: "本月",
  usage: "使用情況",
  plan_quota: "方案配額：{count} 次呼叫",
  name: "名稱",
  api_key: "API 金鑰",
  created_at: "建立時間",
  action: "操作",
  response_status: "狀態碼",
  response_data: "回應數據",
  call_count_name: "呼叫次數",
  update_failed: "更新失敗",
  restricted: "受限",
};
